export default "__VITE_ASSET__3cce2615__"